/*
 * TODO: support cell formatting w/ quotes
 */
const e = "[UNKNOWN VALUE]", o = ({columns: o, rows: n, filename: r}) => {
    const t = (({columns: o}) => o.reduce(((o, n) => {
        if (!n.columnDef?.meta?.hideColumnInCsv) {
            const r = o => {
                if ("string" == typeof o.columnDef?.header) return o.columnDef.header;
                if (o.columnDef?.meta?.formatCsvHeader) {
                    const e = o.columnDef?.meta?.formatCsvHeader();
                    if ("string" == typeof e) return e;
                    "production" !== process.env.NODE_ENV && console.warn("[WARNING]: formatCsvHeader returned a non string value. header could not be determined for the following column: \n", {
                        ...o.columnDef
                    });
                }
                return "production" !== process.env.NODE_ENV && console.warn("[WARNING]: header could not be determined for the following column: \n", {
                    ...o.columnDef
                }), e;
            };
            o.push({
                id: n.id,
                accessor: n?.accessorFn,
                formatter: n.columnDef?.meta?.formatCsvValue,
                header: r(n)
            });
        }
        return o;
    }), []))({
        columns: o
    }), c = (({rows: o, columns: n}) => {
        let r = "";
        const t = n.map((e => `"${e.header}"`)).join(",") + "\n";
        return r += t, o.forEach((o => {
            const t = n.map((n => {
                let r = "";
                return n?.accessor && (r = n.accessor(o.original, o.index)), n?.formatter && (r = n.formatter(o.original)), 
                "number" == typeof r && (r = r.toString()), "string" != typeof r && ("production" !== process.env.NODE_ENV && console.warn("[WARNING]: string value could not be determined for the following: \n", {
                    column: n.header,
                    row: o
                }), r = e), `"${r}"`;
            })).join(",");
            r += t + "\n";
        })), r;
    })({
        rows: n,
        columns: t
    }), a = new Blob([ c ], {
        type: "text/csv"
    }), s = window.URL.createObjectURL(a), l = document.createElement("a");
    l.href = s, l.download = r || `${Date.now()}.csv`, document.body.appendChild(l), 
    l.click();
};

export { o as default };
//# sourceMappingURL=index.js.map
